import { useState, useEffect, ReactNode } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { AccessDeniedPage } from './AccessDeniedPage';

interface GeoBlockProps {
  children: ReactNode;
}

interface GeoCheckResult {
  allowed: boolean;
  country: string;
  countryCode: string;
  isVpn: boolean;
  reason: string;
  city?: string;
}

export const GeoBlock = ({ children }: GeoBlockProps) => {
  const [geoStatus, setGeoStatus] = useState<'checking' | 'allowed' | 'blocked'>('checking');
  const [blockInfo, setBlockInfo] = useState<GeoCheckResult | null>(null);

  useEffect(() => {
    const checkGeo = async () => {
      try {
        const cached = sessionStorage.getItem('geo_check_result');
        if (cached) {
          const result = JSON.parse(cached) as GeoCheckResult;
          if (result.allowed) {
            setGeoStatus('allowed');
          } else {
            setBlockInfo(result);
            setGeoStatus('blocked');
          }
          return;
        }

        const { data, error } = await supabase.functions.invoke('geo-check');
        
        if (error) {
          console.error('Geo check error:', error);
          setGeoStatus('allowed');
          return;
        }

        const result = data as GeoCheckResult;
        sessionStorage.setItem('geo_check_result', JSON.stringify(result));
        
        if (result.allowed) {
          setGeoStatus('allowed');
        } else {
          setBlockInfo(result);
          setGeoStatus('blocked');
        }
      } catch (error) {
        console.error('Geo check failed:', error);
        setGeoStatus('allowed');
      }
    };

    checkGeo();
  }, []);

  if (geoStatus === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (geoStatus === 'blocked' && blockInfo) {
    return <AccessDeniedPage blockInfo={blockInfo} />;
  }

  return <>{children}</>;
};
